import { Badge, Button, Td, Tr, useDisclosure } from "@chakra-ui/react"
import { Form, Icon, IconButton, Profile, Section, Table } from "components"
import { useState } from "react"
import AddLimit from "./addLimit"

export default function Limit(){
    
    const newModal = useDisclosure()
    const columns = [{ children: 'Status' }, { children: 'Limite' }, { children: 'Vigor', isNumeric: true }, { children: 'Responsável' }, { children: 'Criado', isNumeric: true }, { children: '', isNumeric: true }, { children: '', isNumeric: true }]

    return(
    <>
    <Section title="Limite de vendas">
        <Button children="Adicionar restrição" size="xs" leftIcon={<Icon name="add" />} colorScheme="orange" onClick={newModal.onOpen} />
    </Section>

    <Table columns={columns}>
        <Tr>
            <Td><Form.Switch label="Ativo" /></Td>
            <Td><Badge children="100 produtos a cada 7 dias" /></Td>
            <Td isNumeric>De 01/10/2024 até 01/11/2024</Td>
            <Td><Profile name="Administrador" /></Td>
            <Td isNumeric>Hoje às 13:30</Td>
            <Td isNumeric><IconButton label="Excluir limite" variant="outline" size="xs" colorScheme="red" icon="trash" /></Td>
        </Tr>
    </Table>

    <AddLimit {...newModal} />
    </>
    )
}